import type {SVGProps} from 'react'

const SvgPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 24 24'}
    {...props}
  >
    <path
      stroke={'currentColor'}
      strokeWidth={1.25}
      d={'m5.18 6.07 1.863-1.863a1 1 0 0 1 1.414 0l2.04 2.04a1 1 0 0 1 .151 1.222L9.472 9.43a1 1 0 0 0 .15 1.222l4.176 4.175a1 1 0 0 0 1.221.15l1.961-1.176a1 1 0 0 1 1.222.15l2.04 2.041a1 1 0 0 1 0 1.414L18.38 19.27a1 1 0 0 1-.95.263l-4.461-1.116a1 1 0 0 1-.465-.263l-6.208-6.208a1 1 0 0 1-.263-.464L4.917 7.019a1 1 0 0 1 .264-.95Z'}
    />
  </svg>
)
export default SvgPhone
